export const buildGeneralReferralUrl = (origin, userId) => {
  const url = new URL('/', origin);
  url.searchParams.set('ref', userId);
  return url.toString();
};

const copyWithSelection = url => {
  const activeElement = document.activeElement;
  const textarea = document.createElement('textarea');
  textarea.value = url;
  textarea.setAttribute('readonly', '');
  textarea.setAttribute('aria-hidden', 'true');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, textarea.value.length);

  const copied = typeof document.execCommand === 'function' && document.execCommand('copy');
  document.body.removeChild(textarea);
  activeElement?.focus?.();

  if (!copied) {
    throw new Error('Copying the referral link is not supported');
  }
};

export const copyReferralLink = async url => {
  const canUseClipboardApi =
    window.isSecureContext !== false && window.navigator.clipboard?.writeText;
  if (canUseClipboardApi) {
    try {
      await window.navigator.clipboard.writeText(url);
      return;
    } catch (error) {
      // Clipboard API may reject on HTTP LAN origins. Continue with the selection fallback.
    }
  }

  copyWithSelection(url);
};

export const shareReferralLink = async ({ url, title, text }) => {
  if (!window.navigator.share) {
    return 'alternatives';
  }

  try {
    await window.navigator.share({ title, text, url });
    return 'shared';
  } catch (error) {
    return error?.name === 'AbortError' ? 'cancelled' : 'alternatives';
  }
};
